exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "accept-cookie {\n  display: block; }\n  accept-cookie > div {\n    padding: 1rem 0;\n    text-align: center;\n    background-color: #eee;\n    border: 1px solid #dfdcdc;\n    margin-bottom: 1rem; }\n    accept-cookie > div button {\n      margin-left: .5rem; }\n", ""]);

// exports
